<template>
  <v-dialog
    v-model="dialog"
    width="auto"
    data-testid="share-history-popup"
  >
    <v-card class="br-5">
      <v-data-table
        must-sort
        :headers="headers"
        :items="shareHistory"
        :items-per-page="5"
        :items-per-page-options="[5, 10, 25]"
        :loading="isLoadingHistory"
        :sort-by="sortBy"
      >
        <template #loading>
          <v-skeleton-loader
            type="table-row@5"
          />
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
// 3rd Party
import {mapActions} from 'vuex';

// Services and Helpers
import {backendErrorMessage, queryAuditLogs} from '@/services/BackendService';

export default {
  name: 'ShareHistory',
  props: {
    mapId: {
      type: String,
      required: true,
    },
  },
  emits: ['closed'],
  data() {
    return {
      isLoadingHistory: true,
      shareHistory: [],
      dialog: true,
      sortBy: [{key: 'dateAndTime', order: 'desc'}],
      headers: [
        {
          title: 'Initiator',
          key: 'userName',
        },
        {
          title: 'Action',
          key: 'action',
        },
        {
          title: 'Affected User',
          key: 'affectedUser',
        },
        {
          title: 'Date and Time',
          key: 'dateAndTime',
        },
      ],
    };
  },
  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.$emit('closed');
      }
    },
  },
  mounted() {
    this.fetchSharingHistory();
  },
  methods: {
    ...mapActions(['addErrorMessage']),
    async fetchSharingHistory() {
      let json;
      try {
        json = await queryAuditLogs(this.mapId, 'sharingHistory');
      } catch (error) {
        this.isLoadingHistory = false;
        this.addErrorMessage(`Failed to fetch sharing history, ${backendErrorMessage(error)}`);
        return;
      }

      this.shareHistory = this.formatShareHistory(json);
      this.isLoadingHistory = false;
    },
    formatShareHistory(unformattedArray) {
      const formatEventType = (eventType) => {
        const mappedName = {
          'shareSettings-addedEditor': 'Added user',
          'shareSettings-removedEditor': 'Removed user',
          'shareSettings-changedToNpView': 'Changed to NP viewer',
          'shareSettings-changedToNpEdit': 'Changed to NP editor',
          'shareSettings-changedToAnyoneView': 'Turned on public view',
          'shareSettings-changedToAnyoneRestricted': 'Turned on restricted view',
          'duplicated': 'Duplicated',
          'createdOn': 'Map Created',
        }[eventType];
        // If the mapped name isn't found, just return the original event type
        return mappedName ?? eventType;
      };

      const formatAffectedUser = (item) => {
        if (!item.eventPayload) return null;
        const parsedPayload = JSON.parse(item.eventPayload);
        if (item.eventType === 'shareSettings-addedEditor') {
          return parsedPayload.addedEditor?.name;
        } else if (item.eventType === 'shareSettings-removedEditor') {
          return parsedPayload.removedEditor?.name;
        }
        return null;
      };

      return unformattedArray.map((item) => ({
        userName: item.userName,
        action: formatEventType(item.eventType),
        affectedUser: formatAffectedUser(item),
        dateAndTime: new Date(item.eventDate.value).toLocaleString(),
      }));
    },
  },
};
</script>

<style scoped lang="scss">
</style>
